import { MARQUEE } from "../data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-extrabold uppercase tracking-tight sm:text-7xl ${i % 2 ? "font-serif-i normal-case !font-normal text-[var(--acid)]" : ""}`}>{w}</span>
        <span className="text-3xl text-zinc-500">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative -rotate-1 overflow-hidden border-y border-white/10 bg-[var(--surface)] py-6">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </div>
);
